import React from "react";
import * as icons from "../../assets/icons";
export default function NodeIcon({ icon, width, alt, ...otherProps }) {
  return (
    <>
      <img
        width={width ? width : 35}
        {...otherProps}
        alt={alt}
        src={icons[icon] ? icons[icon] : icons.api}
      />
    </>
  );
}
